import React from 'react';
import { connect } from 'react-redux';
import { stableSort } from '../../utils/comparators';
import { percent } from '../../utils/parsing';
import Selector from '../util/Selector';

/**
 * Sort by scores first, score descending
 * TODO: if we add too many more uses of this we should just bake it into the Selector
 */
export const scoreSort = (a, b) => {
  if (a.score == null && b.score == null) return 0;
  if (a.score == null) return 1;
  if (b.score == null) return -1;
  if (a.score < b.score) return 1;
  if (a.score > b.score) return -1;
  return 0;
};

/**
 * Controlled component for choosing a point type, supports a map of predictions
 * (like the ones generated by the auto tagger) in the form { 'Status': 0.04 }
 */
const PointTypeSelector = ({
  pointTypes,
  selected,
  onChange,
  disabled,
  showNullOption,
  filter = () => true,
}) => {
  const options = pointTypes.filter(filter).map(({ id, name, score }) => ({
    id,
    key: `${id}`,
    display: score ? `${name} (${percent(score)})` : name,
  }));
  return (
    <Selector
      options={options}
      selected={selected ? `${selected}` : ''}
      onChange={({ target: { value } }) => onChange(value)}
      disabled={disabled || options.length === 0}
      showNullOption={showNullOption}
    />
  );
};

export default connect(
  (
    {
      entities: {
        pointTypes: { alphabeticalIds, byId, idByName },
      },
    },
    { predictions }
  ) => {
    const predictionsById = Object.entries(predictions ?? {}).reduce((o, [name, score]) => {
      const id = idByName[name];
      if (id) {
        // eslint-disable-next-line no-param-reassign
        o[id] = score;
      }
      return o;
    }, {});
    const pointTypes = alphabeticalIds
      .map((id) => byId[id])
      .map((pt) => ({
        ...pt,
        score: predictionsById[pt.id],
      }));
    const sorted = stableSort(pointTypes, scoreSort);
    return { pointTypes: sorted };
  }
)(PointTypeSelector);
